import published from 'utils/published'
import selector, {identitySelector} from 'utils/selector'
import APIService from './APIService'

type Config = {
  environment: string
  stripePublicKey: string
  imgixDomain: string
}

export default class ConfigService {
  private _config = published<Config>({} as any)

  public get config() {
    return this._config.value
  }

  public loadConfig = async () => {
    const result = await APIService.getConfig()
    if (result.ok) {
      this._config.publish(result.body)
    } else {
      throw new Error(result.error.code)
    }
  }
}

export const configServiceSelector = selector(identitySelector<string>(), () => new ConfigService())
